import { CoreItem, CoreItemBackend } from '../core-item/core-item';

export interface TagBackend extends CoreItemBackend {
  title: string;
  type: TagType;
  unsafeSubData?: TagUnSafeSubData;
  publicSubData?: TagPublicSubData;
}

export enum TagType {
  normal = 'Normal',
}

export interface Tag extends CoreItem {
  title: string;
  unsafeSubData?: TagUnSafeSubData;
  publicSubData?: TagPublicSubData;
}

export interface TagUnSafeSubData {
  color: string;
  personality?: string;
}

export interface TagPublicSubData {
  usedCount?: number;
}
